// extracted by mini-css-extract-plugin
module.exports = {"toggle":"ToggleButton_toggle__3rfTH","toggleButton":"ToggleButton_toggleButton__1RNMm"};